import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './i18n';
import './index.css';
import store from './redux/store';
import { SocketProvider } from './provider/SocketContext';
import { ConversationUpdatesProvider } from './provider/ConversationUpdatesContext';
import { NotificationsProvider } from './provider/NotificationsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <NotificationsProvider>
            <SocketProvider>
                <ConversationUpdatesProvider>
                    <App />
                </ConversationUpdatesProvider>
            </SocketProvider>
        </NotificationsProvider>
    </Provider>
);
